import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { PASSWORD_REQUIREMENTS } from "../utils/passwordPolicy";

type PasswordRequirementsChecklistProps = {
  password: string;
};

export const PasswordRequirementsChecklist: React.FC<PasswordRequirementsChecklistProps> = ({
  password,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: -1 }}>
      {PASSWORD_REQUIREMENTS.map((req) => {
        const met = req.test(password);
        return (
          <Box
            key={req.id}
            sx={{ display: "flex", alignItems: "center", gap: 0.75 }}
          >
            {met ? (
              <CheckCircleIcon sx={{ fontSize: 16, color: "success.main" }} />
            ) : (
              <CancelIcon sx={{ fontSize: 16, color: "text.disabled" }} />
            )}
            <Typography
              variant="caption"
              sx={{ color: met ? "success.main" : "text.secondary" }}
            >
              {req.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
